import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import clsx from 'clsx'
import { TableProjectItem } from 'Models/project'
import { onEnterKeyDown } from 'pages/ProjectsPage/WorkspacePage/components/Common/utils'
import React from 'react'
import { Link } from 'react-router-dom'
import Popout from '../Popout'

const useStyles = makeStyles((theme: Theme) => ({
    popoutBody: {
        padding: theme.spacing(1, 2),
        marginRight: theme.spacing(0.5),
    },
    menuItem: {
        color: theme.palette.secondary.main,
        cursor: 'pointer',
        transition: '200ms',
        padding: theme.spacing(1, 1),
        marginLeft: -theme.spacing(1),
        marginRight: -theme.spacing(1),
        '&:hover': {
            borderRadius: 4,
            backgroundColor: 'rgba(0,0,0,0.2)',
        },
    },
    linkItem: {
        textDecoration: 'none',
        color: theme.palette.secondary.main,
    },
}))
interface ActionColumnPopupInterface {
    isAdmin?: boolean
    actionMenuAnchor?: null | Element
    handleActionMenuClose?: () => void
    currentProject?: Partial<TableProjectItem> | undefined
    handleViewDetailsClick?: (event: React.MouseEvent) => void
    openRemoveProjectConfirmation?: (projectId: string | undefined) => void
}
const ActionColumnPopup: React.FC<ActionColumnPopupInterface> = ({
    isAdmin,
    actionMenuAnchor,
    handleActionMenuClose,
    currentProject,
    handleViewDetailsClick,
    openRemoveProjectConfirmation,
}) => {
    const classes = useStyles()
    const dashboardPath = `/projects/${currentProject?.id}/dashboard`
    const workspacePath = `/projects/${currentProject?.id}/workspace`

    const handleRemoveClick = () => {
        if (currentProject && openRemoveProjectConfirmation) {
            openRemoveProjectConfirmation(currentProject.id)
        }
    }

    return (
        <Popout
            anchorEl={actionMenuAnchor}
            onCloseRequest={handleActionMenuClose}
            className={clsx(classes.popoutBody, 'actionPopout')}
        >
            <GridContainer direction="column">
                <GridItem
                    data-testid="viewDetails"
                    className={classes.menuItem}
                    onClick={handleViewDetailsClick}
                >
                    <Typography
                        variant="body2"
                        onKeyDown={onEnterKeyDown(handleViewDetailsClick)}
                        tabIndex={0}
                    >
                        View Details
                    </Typography>
                </GridItem>
                <GridItem className={classes.menuItem}>
                    <Link
                        data-testid="goToDashboard"
                        to={dashboardPath}
                        className={classes.linkItem}
                    >
                        <Typography variant="body2">Go to Dashboard</Typography>
                    </Link>
                </GridItem>
                <GridItem className={classes.menuItem}>
                    <Link
                        data-testid="goToWorkspace"
                        to={workspacePath}
                        className={classes.linkItem}
                    >
                        <Typography variant="body2">Go to Workspace</Typography>
                    </Link>
                </GridItem>
                {isAdmin && (
                    <GridItem
                        data-testid="removeProject"
                        onClick={handleRemoveClick}
                        className={classes.menuItem}
                    >
                        <Typography
                            variant="body2"
                            onKeyDown={onEnterKeyDown(handleRemoveClick)}
                            tabIndex={0}
                        >
                            Remove Project
                        </Typography>
                    </GridItem>
                )}
            </GridContainer>
        </Popout>
    )
}
export default ActionColumnPopup
